"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPinSchema = exports.VideoPinSettingsSchema = exports.VideoPinItemSchema = exports.VideoSchema = exports.SchoolTvVideoSchema = exports.VimeoVideoSchema = exports.YoutubeVideoSchema = exports.VideoPinSourceSchema = void 0;
const zod_1 = require("zod");
const base_pin_1 = require("./base-pin");
// TODO: not final, copied from 1.0.
exports.VideoPinSourceSchema = zod_1.z.enum(['YOUTUBE', 'VIMEO']);
exports.YoutubeVideoSchema = zod_1.z.object({
    type: zod_1.z.literal('YOUTUBE'),
    /** id of the video */
    id: zod_1.z.string(), // was item.custom.id in the 1.0
    /** optional start time */
    start: zod_1.z.string().nullish(), // was item.custom.start in the 1.0
    /** optional end time */
    end: zod_1.z.string().nullish(), // was item.custom.end in the 1.0
    /** duration of the video */
    duration: zod_1.z.number(), // was item.custom.duration in the 1.0. Note sure if this can be made required
    /** full url of the video */
    url: zod_1.z.string(), // was item.url in the 1.0
    /** low res image provided by youtube */
    image: zod_1.z.string().nullish(), // was item.image in the 1.0
    /** high res image provided by youtube */
    maxResImage: zod_1.z.string().nullish(), // was item.maxresImage in the 1.0
});
exports.VimeoVideoSchema = zod_1.z.object({
    type: zod_1.z.literal('VIMEO'),
    /** id of the video */
    id: zod_1.z.string(), // was item.custom.id in the 1.0
    /** name of the video */
    name: zod_1.z.string().nullish(), // was item.name in the 1.0
    /** optional start time */
    duration: zod_1.z.number(), // was item.custom.duration in the 1.0. Note sure if this can be made required
    /** full url of the video */
    url: zod_1.z.string(), // was item.url in the 1.0
    /** low res image provided by youtube */
    image: zod_1.z.string().nullish(), // was item.image in the 1.0
});
exports.SchoolTvVideoSchema = zod_1.z.object({
    type: zod_1.z.literal('SCHOOLTV'),
    /** name provided (scraped) from schooltv */
    name: zod_1.z.string().nullish(), // was item.name in the 1.0
    /** description of the video */
    subtitle: zod_1.z.string().nullish(), // was item.custom.subtitle in the 1.0
    /** duration of the video */
    duration: zod_1.z.number(), // was item.custom.duration in the 1.0. Note sure if this can be made required
    /** full url of the video */
    url: zod_1.z.string(), // was item.url in the 1.0
    /** image provided by school tv */
    image: zod_1.z.string().nullish(), // was item.image in the 1.0
    /** high res image provided by youtube */
    maxResImage: zod_1.z.string().nullish(), // was item.maxresImage in the 1.0
});
// TODO: do we miss any types?
exports.VideoSchema = zod_1.z.discriminatedUnion('type', [exports.YoutubeVideoSchema, exports.VimeoVideoSchema, exports.SchoolTvVideoSchema]);
exports.VideoPinItemSchema = zod_1.z.object({
    pinId: zod_1.z.string(),
    opacity: zod_1.z.number().optional(),
    over: zod_1.z.boolean().optional(),
    play: zod_1.z.boolean().optional(),
    time: zod_1.z.number(),
    precision: zod_1.z.boolean().optional(),
    end: zod_1.z.number().optional(),
});
exports.VideoPinSettingsSchema = base_pin_1.BasePinSettingsSchema.merge(zod_1.z.object({
    /** if the video is interactive (can have child pins) */
    interactive: zod_1.z.boolean(),
    // TODO: Subtype with interactive: true?
    videoItems: zod_1.z.array(exports.VideoPinItemSchema).optional(),
    video: exports.VideoSchema.nullish(),
    layout: zod_1.z.null().optional(),
}));
exports.VideoPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('VIDEO'),
    settings: exports.VideoPinSettingsSchema,
}));
//# sourceMappingURL=video-pin.js.map